// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ReactAlert from "react-alert";
import * as SimpleAlert$DvmAdminFrontendFr from "../../../alert/SimpleAlert.bs.js";
import * as Utils_Alert$DvmAdminFrontendFr from "../../../common/utils/Utils_Alert.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../context/user/User_Context.bs.js";
import * as Order_Detail_Api$DvmAdminFrontendFr from "./Order_Detail_Api.bs.js";
import * as Order_Detail_Page_Fleet$DvmAdminFrontendFr from "./Order_Detail_Page_Fleet.bs.js";
import * as Order_Detail_Correct_Api$DvmAdminFrontendFr from "./correct/Order_Detail_Correct_Api.bs.js";
import * as Order_Detail_Page_NonFleet$DvmAdminFrontendFr from "./Order_Detail_Page_NonFleet.bs.js";
import * as Order_Detail_Page_Skeleton$DvmAdminFrontendFr from "./Order_Detail_Page_Skeleton.bs.js";

function Order_Detail(Props) {
  var orderId = Props.orderId;
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var alert = ReactAlert.useAlert();
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setOrder = match$2[1];
  var order = match$2[0];
  var match$3 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setCorrectionsResult = match$3[1];
  var correctionsResult = match$3[0];
  var reloadPage = function (param) {
    Order_Detail_Api$DvmAdminFrontendFr.getOrder(userManager, setOrder, orderId, selectedRole);
    Order_Detail_Correct_Api$DvmAdminFrontendFr.getAllCorrections(alert, userManager, setCorrectionsResult, orderId, selectedRole);
  };
  React.useEffect((function () {
          reloadPage(undefined);
        }), []);
  React.useEffect((function () {
          if (typeof order !== "number" && order.TAG === /* Error */1) {
            Utils_Alert$DvmAdminFrontendFr.error(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {
                      message: {
                        TAG: /* RestError */2,
                        _0: order._0
                      }
                    }));
          }
          
        }), [order]);
  if (typeof order === "number") {
    return React.createElement(Order_Detail_Page_Skeleton$DvmAdminFrontendFr.make, {
                orderId: orderId
              });
  }
  if (order.TAG !== /* Ok */0) {
    return React.createElement(Order_Detail_Page_Skeleton$DvmAdminFrontendFr.make, {
                orderId: orderId
              });
  }
  var order$1 = order._0;
  var match$4 = Belt_Option.getWithDefault(order$1.header.orderOrderType, /* NOTSET */16);
  if (match$4 !== 11 && match$4 !== 0) {
    return React.createElement(Order_Detail_Page_NonFleet$DvmAdminFrontendFr.make, {
                order: order$1,
                orderId: orderId,
                reloadPage: reloadPage,
                correctionsResult: correctionsResult
              });
  }
  return React.createElement(Order_Detail_Page_Fleet$DvmAdminFrontendFr.make, {
              order: order$1,
              orderId: orderId,
              reloadPage: reloadPage,
              correctionsResult: correctionsResult
            });
}

var make = Order_Detail;

export {
  make ,
}
/* react Not a pure module */
